import "core-js/modules/es6.regexp.search.js";
import IconTextLink from '~/components/molecules/Header/IconTextLink.vue';
var NavItemTree = function NavItemTree() {
  return import('./NavItemTree.vue');
};
var SearchItem = function SearchItem() {
  return import('~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
};
export default {
  name: 'LayerMobile',
  components: {
    IconTextLink: IconTextLink,
    NavItemTree: NavItemTree,
    SearchItem: SearchItem
  },
  props: {
    navigation: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    helpUrl: {
      type: String,
      default: ''
    },
    storeLocUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    flattened: function flattened() {
      return this.navigation.reduce(function (acc, item) {
        return acc.concat(item.flatable ? item.items : item);
      }, []);
    }
  },
  methods: {
    close: function close() {
      this.$refs.tree.close();
      this.$refs.search.resetForm();
    }
  }
};